/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import {
	Box,
	Flex,
	Icon,
	Grid,
	GridItem,
	Accordion,
	AccordionButton,
	AccordionItem,
	Text,
	Skeleton,
} from '@chakra-ui/react'
import { useLoadStatusAndActivityType } from '../../../hooks/activity.hooks'
import { useAuthContext } from '../../../context/auth.context'
import { useLanguageContext } from '../../../context/locale.context'
import { groupBy } from 'lodash'
import { ACTION_PANEL_VIEW } from '../action-panel'
import { AiOutlineClose } from 'react-icons/ai'
import { sectionDetailedTrack } from '../../repository/repo.utils'
import {
	GA_CATEGORY_FILES,
	GA_CATEGORY_DASHBOARD,
} from './../../repository/repo.utils'

const SortusActivityTypeView = ({
	setpanelView,
	selectedQueue,
	selectedFilter,
	selectedStatus,
	setSelectedStatus,
	statusIndex,
	setStatusIndex,
	optionList,
	onSelect,
	icon,
	selected,
	isCheckBox,
	buttonText = '',
	name,
	isFilter,
	closeOnSelect = true,
	setselectedSort,
	queue,
	...iconProps
}) => {
	const { mutate, isLoading, isError } = useLoadStatusAndActivityType()
	const [data, setdata] = useState(null)
	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const { organization_flag_enable_tag } = authData

	useEffect(() => {
		mutate(
			{ flag: queue.flag || 0 },
			{
				onSuccess: async data => {
					let groupedData
					if (organization_flag_enable_tag === 1) {
						groupedData = groupBy(data, 'tag_type_id')
					} else {
						groupedData = groupBy(data, 'activity_type_category_id')
					}
					setdata(groupedData)
				},
			}
		)
	}, [])
	const isCheck = data => {
		if (!!isCheckBox) {
			return !!selected?.find(i => i.value === data.value)
		} else {
			return data.value === selected?.value
		}
	}
	//organization_flag_enable_tag
	return (
		<Grid
			h='calc(100% - 100px)'
			bg='white'
			w='100%'
			gridTemplateRows='1fr 15fr'
		>
			<GridItem>
				<Flex w='100%' flexBasis='2%'>
					<Icon
						className={`status-activity-view-back-icon`}
						as={AiOutlineClose}
						cursor='pointer'
						color='red.600'
						w={5}
						h={5}
						ml='auto'
						mr='1.7rem'
						mt='1rem'
						onClick={() => {
							sectionDetailedTrack({
								category: GA_CATEGORY_FILES,
								action: 'Activity Status View',
								label: 'Go Back',
							})
							setStatusIndex({ cat: 0, sub_cat: null })
							setpanelView(ACTION_PANEL_VIEW.LIST_VIEW)
						}}
					/>
				</Flex>
			</GridItem>

			<GridItem overflowY='scroll'>
				<Accordion
					flexGrow='1'
					flexBasis='98%'
					allowToggle={true}
					_before={{
						border: 'none',
					}}
					w='full'
					bg='white'
					px={1}
					onChange={e => {
						setStatusIndex({ cat: e, sub_cat: 0 })
					}}
				>
					{!isLoading && !!optionList && !Object.keys(optionList).length ? (
						<Flex alignItems='center' justifyContent='center'>
							<Text>{locale['No content found!']}</Text>
						</Flex>
					) : isLoading ? (
						[1, 2, 3, 4, 5].map(i => {
							return (
								<Skeleton
									boxShadow='md'
									borderRadius='md'
									key={i}
									mb={2}
									w='full'
									h='50px'
								/>
							)
						})
					) : (
						!!data &&
						optionList.map((item, i) => {
							return (
								<AccordionItem
									borderTopWidth='0'
									key={i}
									index={i + 1}
									_last={{
										borderBottomWidth: '0',
									}}
								>
									<AccordionButton
										pb='0.75rem'
										pt='0.75rem'
										borderBottom='1px solid #F1F3F9'
										_hover={{
											background: 'transparent',
										}}
									>
										<Box
											flex='1'
											textAlign='left'
											cursor='pointer'
											onClick={() => {
												sectionDetailedTrack({
													category: GA_CATEGORY_DASHBOARD,
													action: 'DrillDownTable',
													label: 'Select Menu Item',
												})
												onSelect(item, isCheck(item))
												// setselectedSort(item)
												// setSelectedStatus({
												//   ...item.label,
												//   activity_status_id: 0,
												//   activity_type_id: 0,
												//   hideStatus: true,
												//   hideCategory: true,
												//   cat_index: i + 1,
												//   sub_cat_index: null,
												//   tag_id: 0,
												//   tag_type_name: item.label,
												// })
											}}
										>
											<Text fontWeight='500' fontSize='0.875rem'>
												{item.label}
											</Text>
										</Box>
									</AccordionButton>
								</AccordionItem>
							)
						})
					)}
				</Accordion>
			</GridItem>
		</Grid>
	)
}

export default SortusActivityTypeView
